// extracted by mini-css-extract-plugin
export default {"root":"ModalOverlay_root__ThiR3","blur-down":"ModalOverlay_blur-down__oLR6Y","blur-up":"ModalOverlay_blur-up__6ezO5"};